/**
 * @see {@link https://sweetgreen.atlassian.net/wiki/spaces/TD/pages/4528570450/Feature+Flags#%F0%9F%93%9B-Naming-Conventions Naming Conventions}
 */
export const featureFlagDefaults = {
  'OPS-challenges-enabled': false,
  'OPS-kustomer-enabled': false,
  'OPS-enable-maintenance-mode': false,
  'OPS-contentful-enabled': false,
  'OPS-ca-data-request': false,
  'permanent-forced-app-update-enabled': false,
  'permanent-scan-to-pay-enabled': false,
  'permanent-scan-to-pay-shake-listener-enabled': false,
  'permanent-order-help-shortcode-enabled': false,
  'permanent-in-app-review-enabled': false,
  'permanent-apple-wallet-enabled': false,
  'permanent-app-tracking-transparency-enabled': false,
  'permanent-refer-friend-enabled': false,
  'permanent-order-crash-option-enabled': false,
  'permanent-contentful-preview-enabled': false,
  'OPS-sweetpass-enabled': false,
  'OPS-sweetpass-beta-enabled': false,
  'CELS-440-long-sweetpass-detailed-hero-stats-enabled': false,
  'OPS-customer-decoupling-login-enabled': false,
  'XP-2953-short-exclude-deleted-addresses-enabled': false,
  'XP-3179-short-maps-auto-bound-enabled': false,
  'XP-3179-short-maps-offset-enabled': false,
  'XP-3189-short-disable-search-controls-while-fetching-locations': false,
  'XP-3188-short-challenges-cache-enabled': false,
  'MNU-656-deeplink-continue-button-enabled': false,
  'XP-3156-short-locations-results-redesign': false,
  'XP-3212-short-in-store-order-feedback-enabled': false,
  'MNU-834-short-term-sum-calories-enabled': false,
  'XP-3232-permanent-order-to-healthkit-enabled': true,
  'XP-3251-short-delivery-estimate-asap-enabled': true,
  'XP-3260-short-enable-caching-support-for-pdp-state-machine': true,
  'XP-3273-short-enable-location-search-component-enabled': true,
  'XP-3273-short-location-search-component-in-reorder-enabled': true,
  'CELS-507-short-loyalty-svc-promo-codes-enabled': true,
  'CELS-618-short-custom-sweetpass-braze-events-enabled': true,
  'cels-763-short-rework-the-authentication-redirect-flow-enabled': true,
  'CELS-487-short-new-reward-types-enabled': true,
};
